import { Header } from "../../Components/Layout/Header.jsx";
import "./SuperPredah.less";
import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";

// --- Komponenta za Prikaz Obrasca ---
const FormView = ({ setActiveModal, tipoviOgranicenja, tipoviPredaha }) => {
    const [limitType, setLimitType] = useState(31); // 31 = ulog, 32 = gubitak, 33 = predah
    const [duration, setDuration] = useState('24h');
    const [amount, setAmount] = useState('100.00');

    const showAmount = limitType === 31 || limitType === 32; // Prikazuje se samo za ulog i gubitak
    const showDuration = true; // Uvijek se prikazuje

    const handlePostaviClick = () => {
        setActiveModal({
            type: 'confirm-limit',
            data: { limitType, duration, amount }
        });
    };

    if (!tipoviOgranicenja || !tipoviPredaha) {
        return <div>Učitavanje...</div>;
    }

    return (
        <div id="form-view">
            <h1 className="s-predah-title">SuperPredah</h1>
            <p className="s-predah-description">
                SuperPredah ti omogućuje privremeno ograničavanje ili pauzu od igranja. Ove postavke vrijede samo za igre na Sport stranici (Sport, Uživo, Loto, Virtuali). Za Casino igre potrebno je postaviti SuperPredah zasebno kroz Casino.
            </p>
            <form>
                {/* Vrsta ograničenja */}
                <div className="s-predah-form-section">
                    <h2 className="s-predah-section-title">Vrsta</h2>
                    {[{id:31,name:'ulog'}, {id:32,name:'gubitak'}, {id:33,name:'predah'}].map(type => (
                        <div className="s-predah-radio-control" key={type.id}>
                            <input type="radio" id={`vrsta-${type.id}`} name="vrsta" value={type.id} checked={limitType === type.id} onChange={() => setLimitType(type.id)} />
                            <label htmlFor={`vrsta-${type.id}`} className="s-predah-radio-label">
                                <span className="s-predah-radio-custom"></span>
                                {type.name === 'ulog' && 'ograničenje uloga'}
                                {type.name === 'gubitak' && 'ograničenje gubitka'}
                                {type.name === 'predah' && 'predah od igre'}
                            </label>
                        </div>
                    ))}
                </div>

                {/* Iznos */}
                {showAmount && (
                    <div className="s-predah-form-section">
                        <h2 className="s-predah-section-title">Iznos</h2>
                        <input type="number" className="s-predah-input-text" value={amount} onChange={(e) => setAmount(e.target.value)} />
                    </div>
                )}

                {/* Trajanje */}
                {showDuration && (
                     <div className="s-predah-form-section">
                        <h2 className="s-predah-section-title">Trajanje</h2>
                        {((limitType === 'ulog' || limitType === 'gubitak') ? tipoviOgranicenja : tipoviPredaha).map(d => (
                             <div className="s-predah-radio-control" key={d.id}>
                                <input type="radio" id={`trajanje-${d.id}`} name="trajanje" value={d.id} checked={duration === d.id} onChange={() => setDuration(d.id)} />
                                <label htmlFor={`trajanje-${d.id}`} className="s-predah-radio-label">
                                    <span className="s-predah-radio-custom"></span>
                                    {d.naziv}
                                </label>
                            </div>
                        ))}
                    </div>
                )}
                
                <button type="button" className="s-predah-btn s-predah-btn-primary" onClick={handlePostaviClick}>Postavi</button>
            </form>
        </div>
    );
};

// --- Komponenta za Header ---
const SuperPredahHeader = () => (
    <div className="s-predah-header">
        <a href="#" className="s-predah-back-link">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
            </svg>
            Nazad
        </a>
        <div className="s-predah-header-context">
            <span className="s-predah-context-main">Račun</span>
            <span className="s-predah-context-sub">SuperPredah</span>
        </div>
    </div>
);

// --- Komponenta za Prikaz Statusa ---
const StatusView = ({ setActiveModal, limit }) => {
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${day}.${month}.${year} u ${hours}:${minutes}`;
    };

    return (
        <div id="status-view">
             <h1 className="s-predah-title">SuperPredah</h1>
             <div className="s-predah-status-view">
                <p className="s-predah-status-text">
                    <strong>{limit[0].tip === 31 ? 'Postavljeno je ograničenje uloga.' : limit[0].tip === 32 ? 'Postavljeno je ograničenje gubitka.' : 'Postavljen je predah od igre.'}</strong>
                    <br />
                    Do {formatDate(limit[0].ogranicenoDo)} možeš odigrati još <strong>{limit[0].iznos} €</strong>.
                </p>
             </div>
             <button type="button" className="s-predah-btn s-predah-btn-primary" style={{ marginTop: '20px' }} onClick={() => setActiveModal({ type: 'confirm-cancel' })}>Poništi</button>
        </div>
    );
};

// --- Modal Komponenta ---
const Modal = ({ type, data, onConfirm, onCancel, onClose }) => {
    let content;

    const durationMap = {
        '1': '24 sata',
        '2': '7 dana',
        '3': '30 dana',
        '4': '90 dana',
        '5': '365 dana'
    };

    switch (type) {
        case 'confirm-limit': {
            let modalText = '';
            const durationText = durationMap[data.duration];

            if (data.limitType === 'predah') {
                modalText = `Želiš li postaviti predah od igre? Sljedećih ${durationText} nećeš moći igrati.`;
            } else if (data.limitType === 'ulog') {
                modalText = `Želiš li postaviti ograničenje? U sljedeća ${durationText} moći ćeš uložiti maksimalno ${data.amount} €.`;
            } else { // gubitak
                modalText = `Želiš li postaviti ograničenje? U sljedećih ${durationText} moći ćeš izgubiti maksimalno ${data.amount} €.`;
            }

            content = {
                text: modalText,
                buttons: [
                    { text: 'Postavi', className: 's-predah-btn-primary', handler: onConfirm },
                    { text: 'Odustani', className: 's-predah-btn-success', handler: onCancel }
                ]
            };
            break;
        }
        case 'confirm-cancel':
            content = {
                text: 'Želiš li poništiti SuperPredah koji si postavio? Odmah ćeš moći nastaviti igrati.',
                buttons: [
                    { text: 'Poništi', className: 's-predah-btn-primary', handler: onConfirm },
                    { text: 'Odustani', className: 's-predah-btn-success', handler: onCancel }
                ]
            };
            break;
        case 'error':
             content = {
                text: 'Došlo je do greške.',
                buttons: [{ text: 'U redu', className: 's-predah-btn-primary', handler: onClose }]
            };
            break;
        default:
            return null;
    }

    return (
        <div className="s-predah-modal-overlay">
            <div className="s-predah-modal-content">
                <p className="s-predah-modal-text">{content.text}</p>
                <div className="s-predah-modal-buttons">
                    {content.buttons.map(btn => (
                        <button key={btn.text} className={`s-predah-btn ${btn.className}`}  onClick={btn.handler}>
                            {btn.text}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

const SuperPredah = (props) => {
     // true = prikazuje status, false = prikazuje obrazac
    const [limit, setLimit] = useState(null); 
    const [activeModal, setActiveModal] = useState(null); 

    const [tipoviOgranicenja, setTipoviOgranicenja] = useState(null);
    const [tipoviPredaha, setTipoviPredaha] = useState(null);

    useEffect(() => {
        if (!props.userChecked) return;
        if (props.userChecked && !props.user) return;

        getData();
    }, [props.user, props.userChecked]);

    const getData = () => {
        casino.repos.superPredahRepo.get().then(function (data) {
            setTipoviOgranicenja(data.tipOgranicenja);
            setTipoviPredaha(data.tipPredaha);
            if (data.ogranicenja && data.ogranicenja.length > 0) {
                setLimit(data.ogranicenja);
            } else {
                setLimit(null);
            }
        });
    };

    const closeModal = () => setActiveModal(null);

    const handleConfirmLimit = () => {
        console.log("Potvrđeno postavljanje limita", activeModal.data);
         casino.repos.superPredahRepo.create(activeModal.data.limitType, activeModal.data.duration, activeModal.data.amount, false)
         .then((success) => {
            if (!success) {
                setActiveModal({ type: 'error' })
            } else {
                closeModal();
                getData();
            }
        });
    };
    
    const handleConfirmCancel = () => {
        casino.repos.superPredahRepo.create(null, null, null, true)
         .then((success) => {
            if (!success) {
                setActiveModal({ type: 'error' })
            } else {
                closeModal();
                getData();
            }
        });
    };

    const getModalProps = () => {
        if (!activeModal) return {};

        switch (activeModal.type) {
            case 'confirm-limit':
                return {
                    type: activeModal.type,
                    data: activeModal.data,
                    onConfirm: handleConfirmLimit,
                    onCancel: closeModal, // "Odustani" samo zatvara modal,
                    tipoviOgranicenja : tipoviOgranicenja,
                    tipoviPredaha : tipoviPredaha
                };
            case 'confirm-cancel':
                return {
                    type: activeModal.type,
                    data: activeModal.data, // Prosljeđivanje data ako postoji
                    onConfirm: handleConfirmCancel,
                    onCancel: closeModal // "Odustani" samo zatvara modal
                };
            case 'error':
                return {
                    type: activeModal.type,
                    data: activeModal.data, // Prosljeđivanje data ako postoji
                    onClose: closeModal // "U redu" samo zatvara modal
                };
            default:
                return { onClose: closeModal }; // Fallback
        }
    };

    return (
        <>
        {props.userChecked && !props.user ? <Redirect to="/login" /> : null}
         <Header key="header" {...props} />
            <div className="s-predah-body">
                <SuperPredahHeader />
                <div className="s-predah-content-wrapper">
                    {limit 
                        ? <StatusView setActiveModal={setActiveModal} limit={limit} /> 
                        : <FormView setActiveModal={setActiveModal} tipoviOgranicenja={tipoviOgranicenja} tipoviPredaha={tipoviPredaha} />
                    }
                </div>
                
                {activeModal && <Modal {...getModalProps()} />}
            </div>
        </>
    );
};

export default SuperPredah;
